import React from 'react'
import PropTypes from 'prop-types'
import DefaultContent from './DefaultContent'
import ProContent from './ProContent'

const Content = ({
  styledType = 'default',
  title,
  description,
  children,
  onClose,
  borderColor,
  textColor,
  type,
}) => {
  if (styledType === 'pro') {
    return (
      <ProContent title={title} description={description}>
        {children}
      </ProContent>
    )
  }
  return (
    <DefaultContent
      title={title}
      description={description}
      onClose={onClose}
      borderColor={borderColor}
      textColor={textColor}
      type={type}
    >
      {children}
    </DefaultContent>
  )
}

Content.propTypes = {
  styledType: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  borderColor: PropTypes.string,
  textColor: PropTypes.string,
  onClose: PropTypes.func,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.shape,
  ]),
}

Content.defaultProps = {
  styledType: 'default',
  title: undefined,
  type: 'info',
  description: undefined,
  borderColor: undefined,
  textColor: undefined,
  onClose: undefined,
  children: undefined,
}
export default Content
